module.exports = __webpack_public_path__ + "static/media/spain.e69d9d6b.svg";